export default "__VITE_ASSET__DoqOyjoU__"